import { IServiceRequestPreferredServiceTime } from 'src/services/api/ServiceRequest/apiContracts';

// UI-facing alias: one structural definition lives with the API contract.
export type PreferredServiceDay = IServiceRequestPreferredServiceTime;

const otherEntryPrefix = (day: string): string => {
  return `${day} Other: `;
};

export const buildOtherEntry = (day: string, otherValue: string): string => {
  const prefix: string = otherEntryPrefix(day);

  return `${prefix}${otherValue}`;
};

export const removeOtherEntry = (
  selection: string[],
  day: string
): string[] => {
  const prefix: string = otherEntryPrefix(day);

  const withoutOtherEntry: string[] = selection.filter(
    (entry: string) => !entry.includes(prefix)
  );

  return withoutOtherEntry;
};

export const removeDayEntries = (
  selection: string[],
  day: string
): string[] => {
  const withoutDayEntries: string[] = selection.filter(
    (entry: string) => !entry.includes(day)
  );

  return withoutDayEntries;
};

export const toggleEntry = (selection: string[], entry: string): string[] => {
  const isAlreadySelected: boolean = selection.includes(entry);

  if (isAlreadySelected) {
    const withoutEntry: string[] = selection.filter(
      (existing: string) => existing !== entry
    );

    return withoutEntry;
  }

  return [...selection, entry];
};

export const withOtherEntry = (
  selection: string[],
  day: string,
  otherValue: string
): string[] => {
  const withoutExistingOther: string[] = removeOtherEntry(selection, day);
  const newOtherEntry: string = buildOtherEntry(day, otherValue);

  return [...withoutExistingOther, newOtherEntry];
};

export const findOtherValue = (
  selection: string[],
  day: string
): string | null => {
  const prefix: string = otherEntryPrefix(day);

  const existingOtherEntry: string | undefined = selection.find(
    (entry: string) => entry.includes(prefix)
  );

  if (!existingOtherEntry) {
    return null;
  }

  const otherValue: string = existingOtherEntry.replace(prefix, '');

  return otherValue;
};

export const flattenPreferredTimes = (
  preferredServiceTimes: PreferredServiceDay[]
): string[] => {
  const entriesPerDay: string[][] = preferredServiceTimes.map(
    (preferredDay: PreferredServiceDay) => {
      const dayEntries: string[] = preferredDay.slots.map(
        (slot: string) => `${preferredDay.day} ${slot}`
      );

      return dayEntries;
    }
  );

  const allEntries: string[] = entriesPerDay.flat();

  return allEntries;
};

export const preferredDaysInWorkOrder = (
  workDays: string[],
  preferredServiceTimes: PreferredServiceDay[]
): string[] => {
  const preferredDays: string[] = preferredServiceTimes.map(
    (preferredDay: PreferredServiceDay) => preferredDay.day
  );

  const workDaysWithPreferences: string[] = workDays.filter(
    (workDay: string) => preferredDays.includes(workDay)
  );

  return workDaysWithPreferences;
};